const { debounce } = window.BAO.Utils

class ImageSlide extends window.BAO.CustomElement() {
  connectedCallback () {
    if (!this.els?.item?.elements?.length) return
    super.connectedCallback()

    if (this.disabledAtViewportWidth) {
      if (window.innerWidth < this.disabledAtViewportWidth) {
        this.setupImageFade()
      }
    } else {
      this.setupImageFade()
    }
  }

  setupListeners () {
    super.setupListeners()

    this.els.item.elements.forEach(itemEl => {
      this.listeners.add(itemEl, 'mouseenter', this.handleMouseEnter.bind(this))
      this.listeners.add(itemEl, 'focusin', this.handleFocus.bind(this))
    })

    if (this.disabledAtViewportWidth) {
      this.setupImageFade = this.setupImageFade.bind(this)
      this.listeners.add(
        window,
        'resize',
        debounce(event => {
          if (window.innerWidth < this.disabledAtViewportWidth) { this.setupImageFade(event) }
        }, 200),
      )
    }
  }

  handleMouseEnter (event) {
    this.setCurrent(event.target)
  }

  handleFocus (event) {
    const currentItemEl = event.target.closest(this.els.item.selector)
    this.setCurrent(currentItemEl)
  }

  setCurrent (currentItemEl) {
    this.els.item.elements.forEach(itemEl => {
      itemEl.setAttribute('aria-current', false)
    })
    currentItemEl.setAttribute('aria-current', true)
  }

  setupImageFade () {
    // Quit if no images
    if (!this.mobileImages || this.mobileImages.length < 2) return

    // Loop through images and set opacity to 0, apart from the first image
    this.mobileImages.forEach((image, index) => {
      image.style.transition = `opacity ${this.duration}ms ease`
      image.style.opacity = 0

      if (index === 0) {
        image.style.opacity = 1
      }
    })

    this.index = 0
    this.nextIndex = 1
    setInterval(() => {
      this.mobileImages[this.index].style.opacity = 0
      this.mobileImages[this.nextIndex].style.opacity = 1

      this.index++
      this.nextIndex++
    }, this.delay)
  }

  get index () {
    return this._index
  }

  set index (index) {
    const isLast = index === this.mobileImages.length
    this._index = isLast ? 0 : index
  }

  get nextIndex () {
    return this._nextIndex
  }

  set nextIndex (index) {
    const isLast = index === this.mobileImages.length
    this._nextIndex = isLast ? 0 : index
  }

  get mobileImages () {
    return this.els['item-mobile']?.elements
  }

  get duration () {
    return parseInt(this.getAttribute('data-fade-duration')) || 500
  }

  get delay () {
    return parseInt(this.getAttribute('data-fade-delay')) || 8000
  }

  get disabledAtViewportWidth () {
    return this.dataset?.disabledAtViewportWidth
      ? Number(this.dataset.disabledAtViewportWidth)
      : null
  }
}

if (!customElements.get('image-slide')) {
  customElements.define('image-slide', ImageSlide)
}
